/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const DiscountListPage = lazyLoad(
  () => import('./index'),
  module => module.DiscountListPage
);
